import certificateStatusCA from "../language/certificateStatusCA";
import certificateStatusRA from "../language/certificateStatusRA";

export default (language,isRA) =>
{
    let certStatus;
    if(isRA)
        certStatus=certificateStatusRA[language];
    else
        certStatus=certificateStatusCA[language];
    return certStatus;
};